import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { TransactionAmount } from "@components/transactions/TransactionAmount";
import { TransactionListItemDto } from "@common/types/transaction";
import { parseISO } from "date-fns";
import {
    ActionType,
    useTransactionForAuditLog,
} from "@components/auditLog/hooks/useTransactionForAuditLog";
import { AuditLogItem } from "../AuditLogItem";
import styles from "../AuditLogItem.module.scss";

interface ReconciliationTransactionLogItemProps {
    log: AuditLog;
}

export const ReconciliationTransactionLogItem: React.FC<
    ReconciliationTransactionLogItemProps
> = ({ log }) => {
    const createdAtDate = parseISO(log.createdAt.toString());

    const {
        transaction,
        deletedTransactionData,
        transactionDescription,
        actionType,
    } = useTransactionForAuditLog(log);

    const actionText = React.useMemo(() => {
        if (actionType === ActionType.CREATED) {
            return "created transaction:";
        }
        if (actionType === ActionType.DELETED) {
            return "deleted transaction:";
        }
        if (actionType === ActionType.RECONCILED) {
            return "successfully reconciled transaction:";
        }
        return "updated transaction:";
    }, [actionType]);

    return (
        <AuditLogItem
            actorId={log.actorId}
            actorName={log.actorName}
            actorType={log.actorType}
            timestamp={createdAtDate}
        >
            <span> {actionText} </span>
            <div className={styles.transactionDescriptionContainer}>
                {deletedTransactionData
                    ? deletedTransactionData.amount !== null && (
                          <TransactionAmount
                              transaction={
                                  {
                                      amount: deletedTransactionData.amount,
                                      originalAmount:
                                          deletedTransactionData.amount,
                                  } as TransactionListItemDto
                              }
                              addSign
                              color
                          />
                      )
                    : transaction && (
                          <TransactionAmount
                              transaction={
                                  transaction as TransactionListItemDto
                              }
                              addSign
                              color
                          />
                      )}
                <span className={styles.transactionDescription}>
                    {transactionDescription}
                </span>
            </div>
        </AuditLogItem>
    );
};
